module.exports = new __parcel__URL__("miro.cb595030.png").toString();